import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { ApplicationState } from '../../../../../store';
import Declarations from './index';

export default function DeclarationsWrapper() {
  const { applyConfig } = useSelector((state: ApplicationState) => state.applyConfig);

  // If declarations task is disabled, navigate to the next section (information-processing)
  if (applyConfig?.disableDeclarationTask) {
    return <Navigate to="../information-processing" replace />;
  }

  // Otherwise, render the Declarations component
  return <Declarations />;
}
